import { render, staticRenderFns } from "./MessageCustomizeModal.vue?vue&type=template&id=8d1ab93a&scoped=true&"
import script from "./MessageCustomizeModal.vue?vue&type=script&lang=js&"
export * from "./MessageCustomizeModal.vue?vue&type=script&lang=js&"
import style0 from "./MessageCustomizeModal.vue?vue&type=style&index=0&id=8d1ab93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1ab93a",
  null
  
)

export default component.exports